import React, { useState } from 'react';
import { Button } from 'components/ui/button';
import { Input } from 'components/ui/input';

interface Props {
    onOTPLogin: (ecode: string) => void;
    onPasswordLogin: (ecode: string) => void;
    isLoading: boolean;
    error: string;
}

const ECodeStep: React.FC<Props> = ({ onOTPLogin, onPasswordLogin, isLoading, error }) => {
    const [ecode, setEcode] = useState('');

    const handleOtpSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!ecode.trim()) return;

        onOTPLogin(ecode.trim().toUpperCase());
    };

    const handlePasswordLogin = () => {
        if (!ecode.trim()) return;

        onPasswordLogin(ecode.trim().toUpperCase());
    };

    return (
        <div className="w-full max-w-sm border rounded-lg p-6 shadow-sm bg-card">
            <div className="mb-6 text-center">
                <h1 className="text-lg font-semibold">Management Information System</h1>
                <p className="text-sm text-muted-foreground">Enter Employee Code</p>
            </div>

            {error && (
                <div className="mb-4 text-sm text-red-600">
                    {error}
                </div>
            )}

            <form onSubmit={handleOtpSubmit} className="space-y-4">
                <div className="space-y-2">
                    <label
                        htmlFor="ecode"
                        className="text-sm font-medium"
                    >
                        Employee Code
                    </label>

                    <Input
                        id="ecode"
                        value={ecode}
                        onChange={(e) =>
                            setEcode(e.target.value.toUpperCase())
                        }
                        placeholder="Enter employee code"
                        autoComplete="username"
                        disabled={isLoading}
                        required
                    />
                </div>

                <Button
                    type="submit"
                    className="w-full"
                    disabled={!ecode.trim() || isLoading}
                >
                    {isLoading ? 'Sending OTP...' : 'Login with OTP'}
                </Button>

                <Button
                    type="button"
                    variant="outline"
                    className="w-full"
                    disabled={!ecode.trim() || isLoading}
                    onClick={handlePasswordLogin}
                >
                    Login with TransIT
                </Button>
            </form>
        </div>
    );
};

export default ECodeStep;